<template>
  <div
    id="kt_content_container"
    class="d-flex flex-column-fluid align-items-start container-xxl"
  >
    <div class="content flex-row-fluid" id="kt_content">
      <div
        class="row gy-5 g-xl-8 d-flex align-items-center mt-lg-0 mb-10 mb-lg-15"
      >
        <div class="col-xl-6 d-flex align-items-center">
          <h1 class="fs-2hx home-title">
            Uzman psikologlarla görüntülü görüşün, <br />iyi hissetmeye
            başlayın!
          </h1>
        </div>
        <div class="col-xl-6">
          <div class="d-flex flex-stack ps-lg-20 buradan-basla">
            <router-link
              class="card card-xl-stretch mb-5 mb-xl-8"
              :to="{ name: 'complaints' }"
              v-slot="{ href, navigate }"
            >
              <a
                :href="href"
                class="
                  btn btn-icon btn-outline btn-nav
                  h-50px
                  w-50px
                  h-lg-70px
                  w-lg-70px
                  ms-2
                  buradan-basla__button
                "
                @click="navigate"
              >
                <span class="svg-icon svg-icon-1 svg-icon-lg-2hx">
                  <strong>Buradan Başla</strong>: Şikayetini Seç
                </span>
              </a>
            </router-link>
          </div>
        </div>
      </div>
      <div class="row gy-5 g-xl-8">
        <div :class="{ 'col-xl-4': !token, 'col-xl-6': token }" v-if="!token">
          <router-link
            class="card card-xl-stretch mb-5 mb-xl-8"
            :to="{ name: 'login' }"
            v-slot="{ href, navigate, isActive }"
          >
            <a :href="href" :class="{ active: isActive }" @click="navigate">
              <div class="card-body d-flex flex-column flex-stack pb-0 px-0">
                <div
                  class="
                    text-dark
                    fs-2
                    text-left
                    mb-10
                    fw-bolder
                    card-px
                    -textcenter
                  "
                >
                  İndirim fırsatlarını yakalamak için kayıt ol.
                </div>
                <div class="position-relative align-self-center">
                  <img
                    src="assets/media/illustrations/custom/1.png"
                    style="margin-bottom: -5px"
                    class="mw-100 mx-auto h-200px card-rounded"
                  />
                </div>
              </div>
            </a>
          </router-link>
        </div>
        <div :class="{ 'col-xl-4': !token, 'col-xl-6': token }">
          <router-link
            class="card card-xl-stretch mb-5 mb-xl-8"
            :to="{ name: 'complaints' }"
            v-slot="{ href, navigate }"
          >
            <a :href="href" @click="navigate">
              <div class="card-body d-flex flex-column flex-stack pb-0 px-0">
                <div
                  class="
                    text-dark
                    fs-2
                    text-left
                    mb-10
                    fw-bolder
                    card-px
                    -textcenter
                  "
                >
                  Randevun bulunmuyor. Hemen psikoloğunu bul ve randevunu planla
                </div>
                <div class="position-relative align-self-center">
                  <img
                    src="assets/media/illustrations/custom/2.png"
                    class="mw-100 mx-auto h-200px card-rounded"
                  />
                </div>
              </div>
            </a>
          </router-link>
        </div>
        <div :class="{ 'col-xl-4': !token, 'col-xl-6': token }">
          <router-link
            class="card card-xl-stretch mb-5 mb-xl-8"
            :to="{ name: 'complaints' }"
            v-slot="{ href, navigate, isActive }"
          >
            <a :href="href" :class="{ active: isActive }" @click="navigate">
              <div class="card-body d-flex flex-column flex-stack pb-0 px-0">
                <div
                  class="
                    text-dark
                    fs-2
                    text-left
                    mb-10
                    fw-bolder
                    card-px
                    -textcenter
                  "
                >
                  Buradan Başla: Şikayetini Seç
                </div>
                <div class="position-relative align-self-end">
                  <img
                    src="assets/media/illustrations/custom/3.png"
                    class="mw-100 mx-auto h-200px card-rounded"
                  />
                </div>
              </div>
            </a>
          </router-link>
        </div>
      </div>
      <div class="row gy-5 g-xl-8">
        <div class="col-xl-6">
          <div class="card card-xl-stretch mb-xl-8">
            <div class="card-header border-0 pt-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1">Uzmanlarımız</span>
                <span class="text-muted mt-1 fw-bold fs-7"
                  >300'den fazla uzman</span
                >
              </h3>
            </div>
            <div class="card-body py-3">
              <div class="tab-content">
                <div
                  class="tab-pane fade show active"
                  id="kt_table_widget_6_tab_1"
                >
                  <div class="table-responsive">
                    <table class="table align-middle gs-0 gy-3">
                      <thead>
                        <tr>
                          <th class="p-0 w-50px"></th>
                          <th class="p-0 min-w-150px"></th>
                          <th class="p-0 min-w-140px"></th>
                          <th class="p-0 min-w-120px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(expert, index) in experts" :key="index">
                          <td>
                            <div
                              class="symbol symbol-50px me-2"
                              style="cursor: pointer"
                              @click="goProfilePage(expert.id)"
                            >
                              <span
                                class="symbol-label"
                                :style="`background-image: url('https://www.terapikoltugu.app/storage/photos/${expert.photo}')`"
                              >
                              </span>
                            </div>
                          </td>
                          <td>
                            <router-link
                              class="
                                text-dark
                                fw-bolder
                                text-hover-primary
                                mb-1
                                fs-6
                              "
                              :to="{
                                name: 'psychologist',
                                params: { id: expert.id },
                              }"
                              v-slot="{ href, navigate, isActive }"
                            >
                              <a
                                :href="href"
                                :class="{ active: isActive }"
                                @click="navigate"
                              >
                                {{ expert.name }} {{ expert.surname }}
                              </a>
                            </router-link>
                            <span class="text-muted fw-bold d-block">{{
                              expert.title
                            }}</span>
                          </td>
                          <td class="text-end">
                            <router-link
                              class="
                                btn
                                btn-sm
                                btn-icon
                                btn-bg-light
                                btn-active-color-primary
                              "
                              :to="{
                                name: 'psychologist',
                                params: { id: expert.id },
                              }"
                              v-slot="{ href, navigate, isActive }"
                            >
                              <a
                                :href="href"
                                :class="{ active: isActive }"
                                @click="navigate"
                              >
                                <span class="svg-icon svg-icon-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <rect
                                      opacity="0.5"
                                      x="18"
                                      y="13"
                                      width="13"
                                      height="2"
                                      rx="1"
                                      transform="rotate(-180 18 13)"
                                      fill="black"
                                    ></rect>
                                    <path
                                      d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                      fill="black"
                                    ></path>
                                  </svg>
                                </span>
                              </a>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="card card-xl-stretch mb-5 mb-xl-8">
            <div class="card-header border-0 pt-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1"
                  >Testler ve Anketler</span
                >
                <span class="text-muted mt-1 fw-bold fs-7"
                  >Sorunlarınızı tespit ederek başlayın</span
                >
              </h3>
            </div>
            <div class="card-body py-3">
              <div class="table-responsive">
                <table class="table align-middle gs-0 gy-3">
                  <thead>
                    <tr>
                      <th class="p-0 w-50px"></th>
                      <th class="p-0 min-w-150px"></th>
                      <th class="p-0 min-w-140px"></th>
                      <th class="p-0 min-w-120px"></th>
                      <th class="p-0 min-w-40px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(survey, index) in surveys"
                      :key="`survey-${index}`"
                    >
                      <td>
                        <div class="symbol symbol-50px me-2">
                          <span class="symbol-label bg-light-primary"
                            ><span class="svg-icon svg-icon-2x svg-icon-primary"
                              ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z"
                                  fill="black"
                                ></path>
                                <path
                                  opacity="0.3"
                                  d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z"
                                  fill="black"
                                ></path></svg></span
                          ></span>
                        </div>
                      </td>
                      <td>
                        <router-link
                          class="card card-xl-stretch mb-5 mb-xl-8"
                          :to="{ name: 'test', params: { id: survey.id } }"
                          v-slot="{ href, navigate }"
                        >
                          <a
                            :href="href"
                            class="
                              text-dark
                              fw-bolder
                              text-hover-primary
                              mb-1
                              fs-6
                            "
                            @click="navigate"
                          >
                            {{ survey.name }}
                          </a>
                        </router-link>
                      </td>
                      <td class="text-end">
                        <router-link
                          class="card card-xl-stretch mb-5 mb-xl-8"
                          :to="{ name: 'test', params: { id: survey.id } }"
                          v-slot="{ href, navigate }"
                        >
                          <a
                            :href="href"
                            class="
                              btn
                              btn-sm
                              btn-icon
                              btn-bg-light
                              btn-active-color-primary
                            "
                            @click="navigate"
                          >
                            <span class="svg-icon svg-icon-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x="18"
                                  y="13"
                                  width="13"
                                  height="2"
                                  rx="1"
                                  transform="rotate(-180 18 13)"
                                  fill="black"
                                ></rect>
                                <path
                                  d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                  fill="black"
                                ></path>
                              </svg>
                            </span>
                          </a>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content flex-row-fluid" id="kt_content">
        <div class="card">
          <div class="card-body p-lg-20">
            <div class="mb-17">
              <div class="d-flex flex-stack mb-5">
                <h3 class="text-black">Blog Yazıları</h3>
              </div>
              <div class="separator separator-dashed mb-9"></div>
              <div class="row g-10">
                <div
                  class="col-md-4"
                  v-for="(blog, index) in blogs"
                  :key="`blog-${index}`"
                >
                  <div class="card-xl-stretch me-md-6">
                    <router-link
                      class="
                        d-block
                        bgi-no-repeat bgi-size-cover bgi-position-center
                        card-rounded
                        position-relative
                        min-h-175px
                        mb-5
                      "
                      :style="`background-image: url('https://www.terapikoltugu.app/storage/blogs/${blog.img}')`"
                      data-fslightbox="lightbox-video-tutorials"
                      :to="{
                        name: 'blogDetail',
                        params: { id: blog.id },
                      }"
                      v-slot="{ href, navigate, isActive }"
                    >
                      <a
                        :href="href"
                        :class="{ active: isActive }"
                        @click="navigate"
                      >
                      </a>
                    </router-link>

                    <div class="m-0">
                      <router-link
                        class="
                          fs-4
                          text-dark
                          fw-bolder
                          text-hover-primary text-dark
                          lh-base
                        "
                        :to="{
                          name: 'blogDetail',
                          params: { id: blog.id },
                        }"
                        v-slot="{ href, navigate, isActive }"
                      >
                        <a
                          :href="href"
                          :class="{ active: isActive }"
                          @click="navigate"
                          >{{ blog.title }}
                        </a>
                      </router-link>
                      <div class="fw-bold fs-5 text-gray-600 text-dark my-4">
                        {{ blog.description }}
                      </div>
                      <div class="fs-6 fw-bolder">
                        <span
                          class="text-gray-700 text-hover-primary"
                          v-if="blog.user == 'Terapi Koltuğu'"
                          >{{ blog.user }}</span
                        >
                        <router-link
                          v-else
                          class="text-gray-700 text-hover-primary"
                          :to="{
                            name: 'psychologist',
                            params: { id: blog.userId },
                          }"
                          v-slot="{ href, navigate, isActive }"
                        >
                          <a
                            :href="href"
                            :class="{ active: isActive }"
                            @click="navigate"
                            >{{ blog.user }}
                          </a>
                        </router-link>
                        <span class="text-muted"> {{ blog.date }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
export default {
  data() {
    return {
      experts: [],
      surveys: [],
      blogs: [],
      token: this.$store.getters.getAccessToken,
    };
  },
  async created() {
    let _body = document.querySelector("body");
    _body.style.backgroundImage = "url('assets/media/misc/page-bg.jpg')";
    await this.getMainContent();
    this.getSurveys();
    this.getBlogs();
  },
  methods: {
    getMainContent: async function () {
      let vm = this;

      let experts = [];

      let response = await API.getMainContent();

      response.data.forEach((item) => {
        item.users.forEach((user) => {
          experts.push(user);
        });
      });

      vm.experts = [
        ...new Map(experts.map((item) => [item["id"], item])).values(),
      ];

      vm.shuffleExperts();
    },
    shuffleExperts: function () {
      let vm = this;

      for (let i = vm.experts.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [vm.experts[i], vm.experts[j]] = [vm.experts[j], vm.experts[i]];
      }
      return vm.experts;
    },
    getSurveys: async function () {
      let vm = this;

      let response = await API.getSurveys();

      vm.surveys = response.data;
    },
    getBlogs: async function () {
      let vm = this;

      let response = await API.getBlogs();
      vm.blogs = response.data.map((item) => {
        let obj = {};

        obj.id = item.id;
        obj.title = item.title;
        obj.description = vm.makeOneSentence(item.essey);
        obj.date = vm.makeDate(item.created_at);
        obj.img = item.img;
        obj.user = vm.findUser(item.user_id);
        obj.userId = item.user_id;

        return obj;
      });
    },
    makeOneSentence: function (sentence) {
      let firstSentence = sentence.split(".")[0];
      return `${firstSentence}...`;
    },
    findUser: function (id) {
      let vm = this;

      let user = vm.experts.find((item) => item.id == id);

      if (!user) return "Terapi Koltuğu";

      return `${user.name} ${user.surname}`;
    },
    makeDate: function (date) {
      let d = new Date(date);

      let months = [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ];

      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();

      let _date = `${day < 10 ? "0" + day : day} ${months[month]} ${year}`;

      return _date;
    },
    goProfilePage: function (id) {
      this.$router.push({
        name: "psychologist",
        params: {
          id,
        },
      });
    },
  },
};
</script>